import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  cont: {
    marginTop: 4 * theme.spacing.unit,
    marginBottom: 4 * theme.spacing.unit,
    display: 'flex',
    justifyContent: 'center',
  },
});

function LoadingCircle({ classes }) {
  return (
    <div className={classes.cont}>
      <CircularProgress size={28} />
    </div>
  );
}

export default withStyles(styles)(LoadingCircle);
